import { Attendee, CombinedEventStatistics, EventsPeriod, Event } from "../../api";

export const FETCH_ATTENDEES_FOR_PERIOD = "FETCH_ATTENDEES_FOR_PERIOD";
export const FETCH_ATTENDEE_STATISTICS_FOR_PERIOD =
  "FETCH_ATTENDEE_STATISTICS_FOR_PERIOD";
export const SHOW_ATTENDEE_INFO = "SHOW_ATTENDEE_INFO";
export const SET_ATTENDEE_INFO = "SET_ATTENDEE_INFO";
export const HIDE_ATTENDEE_INFO = "HIDE_ATTENDEE_INFO";
export const FETCH_EVENTS_FOR_ATTENDEE = "FETCH_EVENTS_FOR_ATTENDEE";
export const SET_EVENTS_FOR_ATTENDEE_STATE = "SET_EVENTS_FOR_ATTENDEE_STATE";
export const SET_ATTENDEES_STATE = "SET_ATTENDEES_STATE";

export interface AttendeesFilters {
  name?: string;
  company?: string;
  email?: string;
}

//
// ASYNC ACTIONS
//

// Attendee info

export interface FetchAttendeesForPeriodAction {
  type: typeof FETCH_ATTENDEES_FOR_PERIOD;
  period: EventsPeriod;
  filters?: AttendeesFilters;
}

export interface SetAttendeesAction {
  type: "SET_ATTENDEES";
  data: Attendee[];
}

export interface SetAttendeesStateAction {
  type: "SET_ATTENDEES_STATE";
  data: "loading" | "error";
}

export interface FetchAttendeeStatisticsForPeriodAction {
  type: typeof FETCH_ATTENDEE_STATISTICS_FOR_PERIOD;
  period: EventsPeriod;
  filters?: AttendeesFilters;
}

export interface SetAttendeeStatisticsAction {
  type: "SET_ATTENDEE_STATISTICS";
  data: CombinedEventStatistics;
}

export interface ShowAttendeeInfoAction {
  type: typeof SHOW_ATTENDEE_INFO;
  attendeeId: string;
}

export interface HideAttendeeInfoAction {
  type: typeof HIDE_ATTENDEE_INFO;
}

export interface SetAttendeeInfoAction {
  type: typeof SET_ATTENDEE_INFO;
  attendeeId: string;
  data: Attendee | "loading" | "error";
}

export interface FetchEventsForAttendeeAction {
  type: typeof FETCH_EVENTS_FOR_ATTENDEE;
  attendeeId: string;
  period: EventsPeriod;
  data?: Attendee;
}

export interface SetEventsForAttendeeAction {
  type: "SET_EVENTS_FOR_ATTENDEE";
  data: Event[];
}
export interface SetEventsForAttendeeStateAction {
  type: "SET_EVENTS_FOR_ATTENDEE_STATE";
  data: "loading" | "error";
}

// interface ReceiveAttendeeInfoAction {
//   type: "RECEIVE_ATTENDEE_INFO";
//   eventId: number;
//   data: AttendeeStatistics;
// }
// interface ReceiveAttendeeInfoFailedAction {
//   type: "RECEIVE_ATTENDEE_INFO_FAILED";
//   eventId: number;
// }

//
// SET ACTIONS
//

export type KnownAction =
  | FetchAttendeesForPeriodAction
  | SetAttendeesAction
  | SetAttendeesStateAction
  | FetchAttendeeStatisticsForPeriodAction
  | SetAttendeeStatisticsAction
  | ShowAttendeeInfoAction
  | HideAttendeeInfoAction
  | SetAttendeeInfoAction
  | FetchEventsForAttendeeAction
  | SetEventsForAttendeeStateAction
  | SetEventsForAttendeeAction;

// FETCH

export const fetchAttendeesForPeriod = (
  period: EventsPeriod,
  filters?: AttendeesFilters
): FetchAttendeesForPeriodAction => ({
  type: "FETCH_ATTENDEES_FOR_PERIOD",
  period,
  filters,
});

export const fetchAttendeeStatisticsForPeriod = (
  period: EventsPeriod,
  filters?: AttendeesFilters
): FetchAttendeeStatisticsForPeriodAction => ({
  type: "FETCH_ATTENDEE_STATISTICS_FOR_PERIOD",
  period,
  filters,
});

export function showAttendeeInfo(attendeeId: string): ShowAttendeeInfoAction {
  return { type: "SHOW_ATTENDEE_INFO", attendeeId };
}

export function hideAttendeeInfo(): HideAttendeeInfoAction {
  return { type: "HIDE_ATTENDEE_INFO" };
}

export function setAttendeeInfo(
  attendeeId: string,
  data: Attendee | "loading" | "error"
): SetAttendeeInfoAction {
  return { type: "SET_ATTENDEE_INFO", attendeeId, data };
}

export function fetchEventsForAttendee(
  attendeeId: string,
  period: EventsPeriod,
  data?: Attendee | undefined
): FetchEventsForAttendeeAction {
  return { type: "FETCH_EVENTS_FOR_ATTENDEE", attendeeId, period, data };
}

export function fetchEventsForAttendeeState(
  data: "loading" | "error"
): SetEventsForAttendeeStateAction {
  return { type: "SET_EVENTS_FOR_ATTENDEE_STATE", data };
}

export function setAttendeesStateAction(
  data: "loading" | "error"
): SetAttendeesStateAction {
  return { type: "SET_ATTENDEES_STATE", data };
}
